import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card'
import { formatInteger, formatPercent } from './formatters'
import type { TopTopicsPanel } from '@/types/analytics'

interface TopTopicsCardProps {
  data: TopTopicsPanel
}

export function TopTopicsCard({ data }: TopTopicsCardProps) {
  if (data.topics.length === 0) {
    return (
      <Card className="p-4">
        <CardHeader className="px-0 pb-3">
          <CardTitle className="text-base">Top topics</CardTitle>
          <CardDescription>Auto-classified</CardDescription>
        </CardHeader>
        <CardContent className="px-0 text-sm text-muted-foreground">No topic data for this range.</CardContent>
      </Card>
    )
  }

  return (
    <Card className="p-4">
      <CardHeader className="px-0 pb-3">
        <CardTitle className="text-base">Top topics</CardTitle>
        <CardDescription>Auto-classified, top {data.topics.length}</CardDescription>
      </CardHeader>
      <CardContent className="px-0 space-y-2">
        {data.topics.map((topic) => (
          <div key={topic.topic_id} className="space-y-1">
            <div className="flex justify-between text-xs">
              <span className="font-medium">{topic.name}</span>
              <span className="text-muted-foreground tabular-nums">
                {formatInteger(topic.count)} · {formatPercent(topic.pct, 0)}
              </span>
            </div>
            <div className="h-1.5 rounded-full bg-muted overflow-hidden">
              <div
                className="h-full bg-primary/70 rounded-full"
                style={{ width: `${Math.round(topic.pct * 100)}%` }}
              />
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
